/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:2e16cb0b-4a13-4402-adfb-5f2e26c76d74",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_P3VYxT1uY",
    "aws_user_pools_web_client_id": "17o1nqnpr4eadqvslugudpg85k",
    "oauth": {}
};


export default awsmobile;
